import { defineRule } from "vee-validate";
import * as rules from "@vee-validate/rules";
import moment from "moment";

Object.keys(rules).forEach((rule) => {
  defineRule(rule, rules[rule]);
});

import { configure } from "vee-validate";
configure({
  validateOnInput: true,
});

